var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var PacemToastElement_1;
import { P, PCSS, CustomElement, Watch, Components, Utils, PropertyConverters, CustomElementUtils, Transformer } from '@pacem/pacem-core';
//namespace Pacem.Components.UI {
const PACEM_TOAST_POPS = "pacem:toast:pops";
let PacemToastElement = PacemToastElement_1 = class PacemToastElement extends Components.PacemElement {
    constructor() {
        super(...arguments);
        this.autohide = true;
        this.timeout = 3000;
        this._doHide = (evt) => {
            window.clearTimeout(this._handle);
            this.show = false;
        };
    }
    connectedCallback() {
        super.connectedCallback();
        this.addEventListener('click', this._doHide, false);
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        if (name === 'show') {
            if (val !== true) {
                Utils.removeClass(this, 'toast-show');
                Utils.addClass(this, 'toast-hide');
                this.dispatchEvent(new CustomEvent('close'));
                Utils.waitForAnimationEnd(this, 1000).then(() => {
                    Utils.removeClass(this, 'toast-hide');
                });
            }
            else {
                let order = CustomElementUtils.getAttachedPropertyValue(PacemToastElement_1, PACEM_TOAST_POPS, 0) - 1;
                CustomElementUtils.setAttachedPropertyValue(PacemToastElement_1, PACEM_TOAST_POPS, order);
                this.style.order = '' + order;
                Utils.addClass(this, 'toast-show');
                this._show();
            }
        }
    }
    disconnectedCallback() {
        this.removeEventListener('click', this._doHide, false);
        super.disconnectedCallback();
    }
    _show() {
        window.clearTimeout(this._handle);
        if (this.disabled) {
            return;
        }
        if (this.autohide) {
            this._handle = window.setTimeout(() => { this.show = false; }, this.timeout);
        }
    }
    popup() {
        if (this.show) {
            this._show();
        }
        else {
            this.show = true;
        }
    }
    /**
     * Opinionated shortcut/utility for toast spinning.
     * @param toaster Toast container
     * @param level Message criticity level
     * @param message The message
     * @param options Further options object
     */
    static toast(toaster, level, message, options) {
        var toast = new PacemToastElement_1();
        if (!Utils.isNullOrEmpty(options?.cssClass)) {
            const cssClass = Utils.isArray(options.cssClass) ? options.cssClass.join(' ') : options.cssClass;
            Utils.addClass(toast, cssClass);
        }
        else {
            toast.className = 'toast-' + level;
        }
        if (!Utils.isNull(options?.autohide)) {
            toast.autohide = options.autohide;
        }
        if (options?.timeout > 0) {
            toast.timeout = options.timeout;
        }
        // icon
        const icon = document.createElement('i');
        icon.className = PCSS + '-icon text-bigger-steady ' + PCSS + '-margin margin-right-1 flex-auto';
        var ligature = 'info';
        switch (level) {
            case 'danger':
            case 'error':
                ligature = 'error';
                break;
            case 'warning':
                ligature = 'warning';
                break;
            case 'success':
                ligature = 'check_circle';
                break;
        }
        icon.textContent = ligature;
        const container = document.createElement('div');
        Utils.addClass(container, 'display-flex flex-stretch flex-start flex-nowrap');
        container.appendChild(icon);
        // caption
        const caption = document.createElement('span');
        Utils.addClass(caption, 'text-small text-pre');
        if (typeof message === 'string') {
            caption.innerHTML = message;
        }
        else {
            caption.appendChild(message);
        }
        container.appendChild(caption);
        toast.appendChild(container);
        toaster.appendChild(toast);
        // promise
        return new Promise((resolve, _) => {
            window.setTimeout(() => {
                toast.popup();
            }, // needs some time to digest
            // state and transition
            100);
            const callback = () => {
                toast.removeEventListener('close', callback, false);
                resolve();
                Utils.waitForAnimationEnd(toast, 1000).then(_ => {
                    toast.remove();
                });
            };
            toast.addEventListener('close', callback, false);
        });
    }
    static toast2(toaster, level, message, options) {
        let cssClass = options?.cssClass;
        let cssArray = ['fill-' + level + '-container', 'fill-glass', 'border-solid', 'border-size--2', 'border-round', 'border-radius--6'];
        if (!Utils.isNullOrEmpty(cssClass)) {
            if (Utils.isArray(cssClass)) {
                Array.prototype.push.apply(cssArray, cssClass);
            }
            else {
                Array.prototype.push.apply(cssArray, cssClass.split(' '));
            }
        }
        return PacemToastElement_1.toast(toaster, level, message, Utils.extend({}, options ?? {}, { cssClass: cssArray }));
    }
};
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Boolean })
], PacemToastElement.prototype, "autohide", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], PacemToastElement.prototype, "timeout", void 0);
__decorate([
    Watch({ converter: PropertyConverters.Boolean })
], PacemToastElement.prototype, "show", void 0);
__decorate([
    Transformer("poptoast")
], PacemToastElement, "toast", null);
__decorate([
    Transformer("poptoastcontainer")
], PacemToastElement, "toast2", null);
PacemToastElement = PacemToastElement_1 = __decorate([
    CustomElement({
        tagName: P + '-toast'
    })
], PacemToastElement);
export { PacemToastElement };
